import { Component, EventEmitter } from '@angular/core';
import { EditBlockBase } from '../../edit-block-base';
import { MatFormField } from "@angular/material/form-field";
import { TranslateModule } from "@ngx-translate/core";
import { MatInput } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";

@Component({
  selector: 'session-comment-edit',
  standalone: true,
  providers: [],
  styleUrls: ['./../component-edit.scss'],
  imports: [
    MatFormField,
    TranslateModule,
    MatInput,
    FormsModule,
    CdkTextareaAutosize
  ],
  templateUrl: './session-comment-edit.html'
})
export class SessionCommentEditComponent extends EditBlockBase {
    public onCommentChange(event: EventEmitter<any>): void {
        this.baseComponent.onChanged.emit();
    }
}
